import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_PAUSE_OFFER_REWARDS = 'GET_PAUSE_OFFER_REWARDS';
export const GET_PAUSE_OFFER_REWARDS_RESPONSE = 'GET_PAUSE_OFFER_REWARDS_RESPONSE';

export const getPauseOfferRewards = () =>
  makeApiRequest({
    requestType: GET_PAUSE_OFFER_REWARDS,
    method: RequestService.getPauseOfferRewards,
  });
